<!-- Zeigt den Status eines Reisetermins als farbiges Pill-Badge -->
<template>
  <span class="pill-badge" :class="klassen" :style="farben">{{ label }}</span>
</template>

<script>
import {
  reiseterminStateFormatter,
  reiseterminStateColors,
  grauPillColors,
  pillColorStyleObject,
} from '@/core/common/helpers/utils';

export default {
  name: 'ReiseterminStateBadge',
  props: {
    state: { type: String, default: null },
    // Kompakte Variante für Filterlisten und Dropdowns
    small: { type: Boolean, default: false },
    // Feste Breite für Badges, die untereinander stehen
    festeBreite: { type: Boolean, default: false },
  },
  computed: {
    label() {
      return reiseterminStateFormatter[this.state] ?? this.state;
    },
    farben() {
      return pillColorStyleObject(reiseterminStateColors[this.state] ?? grauPillColors);
    },
    klassen() {
      return {
        'pill-badge--small': this.small,
        'pill-badge--reisetermin-state': this.festeBreite,
        // Verworfene Reisetermine werden abgeschwächt dargestellt
        'pill-badge--muted': this.state === 'Verworfen',
      };
    },
  },
};
</script>
